Alpine.data('SevenCountryModal', (el) => ({
    getLink(language) {
        return document.querySelector(`link[rel="alternate"][hreflang="${language.replace('_', '-')}"]`)?.href;
    }
}));